import { useEffect, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { bindForbiddenHandler } from "./forbidden.js";

/** Liga o tratamento global de 403 ao React Router. */
export function ApiBootstrap({ children }: { children: ReactNode }) {
  const navigate = useNavigate();

  useEffect(() => {
    bindForbiddenHandler(() => {
      if (window.location.pathname === "/acesso-negado") return;
      navigate("/acesso-negado", { replace: true });
    });
    return () => {
      bindForbiddenHandler(null);
    };
  }, [navigate]);

  return children;
}
